var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAileronBlackWebfont(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "aileronblack",
    horizAdvX: 1355
  }, /*#__PURE__*/React.createElement("fontFace", {
    unitsPerEm: 2048,
    ascent: 1577,
    descent: -471
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 360
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB01",
    horizAdvX: 1363,
    d: "M39 856v229h117v9q0 81 2 118q6 80 35.5 139t91 103.5t165 67t250.5 22.5q94 0 185 -16v-240q-138 8 -214 -1t-108 -35t-37 -76q-2 -29 -2 -82v-9h729v-1085h-368v856h-361v-856h-368v856h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB02",
    horizAdvX: 1386,
    d: "M39 856v229h96v9q0 61 2 98q6 80 40 142t102.5 110.5t184.5 74t277 25.5q300 0 492 -63v-1088q0 -73 4 -100q6 -46 32 -61.5t89 -12.5v-227q-117 -12 -236 -12q-115 0 -181.5 53.5t-72.5 159.5q-4 57 -4 194v893q-48 14 -123 14q-116 0 -172.5 -29t-62.5 -89 q-2 -29 -2 -82v-9h223v-229h-223v-856h-369v856h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 682
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 360
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\t",
    horizAdvX: 360
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 360
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 573,
    d: "M102 154q0 82 51.5 133t133.5 51t133 -51t51 -133t-51 -132.5t-133 -50.5t-133.5 50.5t-51.5 132.5zM121 1413h332l-25 -983h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 839,
    d: "M59 1505h308l-33 -606h-242zM449 1505h307l-33 -606h-242z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    d: "M145 412v196h213l43 197h-194v196h235l88 412h209l-88 -412h178l89 412h208l-88 -412h172v-196h-213l-43 -197h195v-196h-236l-88 -412h-209l89 412h-179l-88 -412h-209l88 412h-172zM567 608h178l41 197h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    d: "M86 412h348q22 -131 152 -176v327q-111 39 -188.5 79t-136.5 92.5t-87.5 119.5t-28.5 152q0 97 36 175.5t98.5 130t139.5 82.5t167 42v161h205v-161q218 -22 335 -138t138 -301h-349q-20 136 -124 177v-316q255 -80 366 -186.5t111 -286.5q0 -177 -131 -283t-346 -127 v-159h-205v159q-459 41 -500 437zM479 1042q0 -55 26 -87.5t81 -53.5v279q-50 -15 -78.5 -50.5t-28.5 -87.5zM791 229q124 24 124 138q0 49 -27.5 84t-96.5 63v-285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1601,
    d: "M63 1096q0 165 86.5 255.5t241.5 90.5t241.5 -90.5t86.5 -255.5q0 -164 -87 -255t-241 -91t-241 91t-87 255zM227 0l916 1413h252l-916 -1413h-252zM285 1096q0 -174 106 -174q107 0 107 174t-107 174q-106 0 -106 -174zM883 317q0 165 86.5 256t240.5 91t241 -91 t87 -256q0 -164 -87 -255t-241 -91t-240.5 91t-86.5 255zM1104 317q0 -174 106 -174q107 0 107 174q0 175 -107 175q-106 0 -106 -175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1409,
    d: "M90 365q0 150 92 241t252 117q-117 34 -187.5 120t-70.5 197q0 196 143 299t410 103q119 0 205 -21v-264q-98 14 -195 14q-91 0 -134.5 -36.5t-43.5 -114.5q0 -75 41.5 -115t108.5 -43q37 -2 114 -2h35v158h369v-158h188v-287h-188v-546q-265 -56 -559 -56 q-580 0 -580 394zM475 410q0 -94 53.5 -131t151.5 -37q89 0 180 14v317h-67q-64 0 -105 -2q-103 -5 -158 -45.5t-55 -115.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 450,
    d: "M59 1505h308l-33 -606h-242z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 825,
    d: "M244 717q0 283 80 498.5t239 381.5h182q-142 -202 -211 -413.5t-69 -466.5t69 -467t211 -414h-182q-319 334 -319 881z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 819,
    d: "M74 -164q142 202 211 414t69 467t-69 466.5t-211 413.5h182q159 -166 239 -381.5t80 -498.5q0 -547 -319 -881h-182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 1290,
    d: "M231 563l72 228l252 -113l-29 295h238l-29 -295l252 113l72 -228l-273 -59l203 -230l-192 -139l-152 256l-151 -256l-193 139l203 230z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    d: "M217 559v180h358v404h205v-404h359v-180h-359v-403h-205v403h-358z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 544,
    d: "M-53 -254l164 606h342v-20l-224 -586h-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 643,
    d: "M66 481v197h512v-197h-512z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 544,
    d: "M82 176q0 91 57 148t148 57t148 -57t57 -148t-57 -148t-148 -57t-148 57t-57 148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 708,
    d: "M-10 -61l514 1536h215l-514 -1536h-215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    d: "M94 707q0 363 141.5 549t442.5 186t442.5 -186t141.5 -549q0 -362 -141.5 -549t-442.5 -187t-442.5 187t-141.5 549zM479 707q0 -252 49 -358.5t150 -106.5t150 106.5t49 358.5q0 172 -23.5 275.5t-66 146t-109.5 42.5t-109.5 -42.5t-66 -146t-23.5 -275.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    d: "M242 803v330l350 200q141 80 289 80h159v-1413h-368v1028z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    d: "M119 0v160l444 418q163 153 223 243t60 189q0 79 -42.5 122.5t-117.5 43.5q-79 0 -121 -52t-53 -163l-2 -21h-369l2 21q23 235 169.5 360t404.5 125q246 0 380 -111.5t134 -310.5q0 -126 -73 -243t-275 -312l-189 -182h520v-287h-1095z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    d: "M68 449h368l4 -21q16 -80 70.5 -133t140.5 -53q94 0 150.5 47.5t56.5 120.5q0 89 -61 136t-174 52l-56 2v238l56 4q98 7 150 56t52 124q0 70 -40.5 109.5t-116.5 39.5t-115.5 -51.5t-46.5 -128.5l-2 -20h-369l2 20q10 92 48.5 171.5t106.5 143t174 100t239 36.5 q126 0 224.5 -30.5t158.5 -83t91 -119.5t31 -144q0 -256 -268 -322q152 -29 226.5 -108t74.5 -215q0 -204 -156 -326.5t-421 -122.5t-419.5 121t-176.5 336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    d: "M78 315v203l631 895h401v-811h172v-287h-172v-315h-369v315h-663zM457 602h284v422q-58 -102 -75 -125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    d: "M117 418h368l2 -21q8 -73 51 -114t117 -41q99 0 151 62.5t52 162.5t-51.5 162.5t-144.5 62.5q-70 0 -113 -31t-68 -96h-340l105 848h942v-287h-639l-45 -309l53 94q93 52 219 52q215 0 341 -128.5t126 -357.5q0 -120 -47 -218t-126 -160t-179 -95t-211 -33 q-260 0 -399 102t-162 324z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    d: "M111 680q0 360 165.5 561t446.5 201q231 0 361 -108t155 -302l2 -20h-369l-4 20q-22 73 -61.5 106t-104.5 33q-104 0 -159 -103.5t-62 -322.5l66 127q54 42 112 58t136 16q117 0 207 -35.5t144.5 -98t81.5 -142t27 -172.5q0 -126 -47 -228.5t-126.5 -166.5t-180.5 -98 t-213 -34q-291 0 -434 172.5t-143 536.5zM496 461q0 -100 50.5 -159.5t137.5 -59.5q89 0 137.5 61t48.5 150q0 104 -50 163.5t-140 59.5q-78 0 -131 -58t-53 -157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    d: "M117 1126v287h1149v-205l-656 -1208h-403l622 1126h-712z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    d: "M104 401q0 132 77 220t194 129q-201 69 -201 292q0 179 138 289.5t386 110.5q247 0 384 -110t137 -290q0 -217 -236 -292q116 -39 192 -126.5t76 -222.5q0 -90 -28.5 -162.5t-79.5 -122.5t-123.5 -83.5t-158.5 -48.5t-187 -15q-570 0 -570 432zM485 422q0 -87 51 -134.5 t142 -47.5q192 0 192 176q0 90 -51 141t-143 51q-81 0 -136 -50t-55 -136zM549 1026q0 -75 38 -114.5t103 -39.5q67 0 110.5 40t43.5 114q0 69 -41.5 107t-110.5 38q-62 0 -102.5 -38.5t-40.5 -106.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    d: "M100 915q0 102 30.5 188.5t84.5 148t126 105t155 64.5t172 21q291 0 434 -172.5t143 -536.5q0 -362 -163.5 -562t-448.5 -200q-237 0 -367 108t-149 302l-2 20h368l4 -20q15 -73 55 -106t111 -33q104 0 159 103.5t62 322.5l-65 -127q-54 -42 -112 -58t-136 -16 q-117 0 -207 35.5t-144.5 98t-82 142t-27.5 172.5zM485 961q0 -104 50.5 -164t140.5 -60q78 0 131 58t53 157q0 100 -50.5 159.5t-137.5 59.5q-89 0 -138 -60.5t-49 -149.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 544,
    d: "M82 176q0 91 57 148t148 57t148 -57t57 -148t-57 -148t-148 -57t-148 57t-57 148zM82 918q0 91 57 147.5t148 56.5t148 -56.5t57 -147.5t-57 -148t-148 -57t-148 57t-57 148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 544,
    d: "M-53 -254l164 606h342v-41l-224 -565h-282zM82 918q0 91 57 147.5t148 56.5t148 -56.5t57 -147.5t-57 -148t-148 -57t-148 57t-57 148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    d: "M219 403v279l965 362v-241l-727 -258l727 -260v-244z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    d: "M176 354v181h1004v-181h-1004zM176 764v180h1004v-180h-1004z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    d: "M143 41v242l727 260l-727 258v243l965 -362v-279z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 1206,
    d: "M61 971q6 221 151.5 346t393.5 125q237 0 369.5 -103.5t132.5 -291.5q0 -118 -50 -199t-167 -176q-81 -66 -113 -115t-41 -127h-299q3 119 33 189t100 145q85 90 118.5 144.5t33.5 107.5q0 155 -143 155q-141 0 -150 -200h-369zM408 154q0 82 51 133t133 51t133 -51 t51 -133t-51 -132.5t-133 -50.5t-133 50.5t-51 132.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1904,
    d: "M90 514q0 197 73 369.5t198.5 294t299.5 191t371 69.5q152 0 282.5 -39.5t223 -108t158 -159.5t97.5 -195t32 -215q0 -125 -25.5 -224t-69.5 -165.5t-106.5 -110t-133.5 -63t-153 -19.5q-243 0 -311 203l-63 -129q-77 -61 -181 -61q-57 0 -104 17.5t-87 55.5t-62.5 107.5 t-22.5 165.5q0 221 109 363.5t280 142.5q57 0 98 -16.5t60 -41.5l34 -108l41 129h310l-66 -273q-39 -164 -39 -225q0 -133 84 -133q80 0 133.5 96t53.5 268q0 253 -155 397t-425 144q-108 0 -212 -30.5t-194.5 -91t-159 -145t-108 -199.5t-39.5 -247q0 -282 158.5 -444 t458.5 -162q271 0 456 133l76 -172q-124 -80 -270.5 -118.5t-290.5 -38.5q-115 0 -225.5 25.5t-217.5 86t-187.5 149t-129.5 224.5t-49 303zM842 522q0 -121 69 -121q68 0 93 107l32 145q9 45 -4.5 73t-50.5 28q-58 0 -98.5 -65.5t-40.5 -166.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1447,
    d: "M8 0l510 1413h451l510 -1413h-402l-119 367h-440l-119 -367h-391zM608 653h262l-131 434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1394,
    d: "M164 0v1413h579q109 0 181 -8q171 -21 267.5 -120.5t96.5 -240.5q0 -98 -52 -169t-155 -107q260 -74 260 -342q0 -76 -24 -142t-63.5 -112.5t-92.5 -82t-109.5 -55t-115.5 -26.5q-72 -8 -209 -8h-563zM532 287h199q65 0 92 2q53 3 93 43.5t40 105.5q0 67 -41 106t-102 44 q-27 2 -92 2h-189v-303zM532 856h166q50 0 90 6q115 17 115 129q0 113 -112 129q-40 6 -93 6h-166v-270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1503,
    d: "M111 696q0 180 55 323.5t150.5 235t221.5 139.5t271 48q147 0 265 -37.5t195.5 -105t122.5 -156.5t56 -195l2 -20h-369l-4 20q-45 223 -272 223q-138 0 -223.5 -116t-85.5 -336q0 -104 17 -186t45.5 -136t68.5 -89.5t84.5 -50.5t95.5 -15q107 0 175 62.5t91 180.5l4 21 h369l-2 -21q-26 -249 -201 -381.5t-448 -132.5q-144 0 -267 46.5t-216.5 135.5t-147 228.5t-53.5 314.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1533,
    d: "M164 0v1413h534q109 0 181 -8q127 -14 232.5 -60.5t189 -127t130 -206t46.5 -286.5t-47 -292.5t-129.5 -219t-189.5 -139.5t-232 -66q-72 -8 -181 -8h-534zM532 287h115q86 0 133 4q140 12 226 127t86 301q0 184 -84.5 287.5t-227.5 115.5q-47 4 -133 4h-115v-839z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1308,
    d: "M164 0v1413h1063v-287h-695v-274h654v-287h-654v-278h715v-287h-1083z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1259,
    d: "M164 0v1413h1063v-287h-695v-274h633v-287h-633v-565h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1554,
    d: "M111 696q0 179 57.5 323t156.5 235t228 139.5t276 48.5t265 -37.5t195.5 -105t122.5 -156.5t56 -195l2 -20h-368l-4 20q-45 223 -273 223q-143 0 -236 -116.5t-93 -335.5q0 -129 26 -224t72.5 -149t103.5 -79t125 -25q108 0 179.5 54.5t109.5 170.5h-274v287h622v-754 h-286l-35 217l-62 -156q-59 -50 -134 -70t-191 -20q-142 0 -259.5 47t-202.5 137t-132 228t-47 313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1576,
    d: "M164 0v1413h368v-577h566v577h368v-1413h-368v549h-566v-549h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 643,
    d: "M164 0v1413h368v-1413h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 1306,
    d: "M98 541h369l4 -62q8 -130 57 -183.5t134 -53.5q149 0 165 178q4 47 4 135v858h369v-801q0 -111 -6 -215q-11 -196 -145 -311t-398 -115q-277 0 -410 133.5t-141 374.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1521,
    d: "M164 0v1413h368v-625l539 625h440l-610 -665l592 -748h-461l-399 545l-101 -111v-434h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1286,
    d: "M164 0v1413h368v-1102h715v-311h-1083z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1890,
    d: "M164 0v1413h575l240 -1055l240 1055h561v-1413h-369v594q0 305 4 448q-40 -227 -98 -448l-156 -594h-379l-157 594q-62 232 -97 448q4 -143 4 -448v-594h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1626,
    d: "M164 0v1413h459l536 -975q-12 172 -12 371v604h369v-1413h-482l-514 934q12 -143 12 -350v-584h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1613,
    d: "M111 707q0 340 196 537.5t527 197.5t526.5 -197.5t195.5 -537.5q0 -339 -195.5 -537.5t-526.5 -198.5t-527 198.5t-196 537.5zM487 707q0 -222 92.5 -343.5t254.5 -121.5q161 0 253.5 121.5t92.5 343.5q0 223 -92 343.5t-254 120.5t-254.5 -120.5t-92.5 -343.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1318,
    d: "M164 0v1413h532q127 0 222 -10q79 -10 148 -42.5t124 -86.5t87 -136.5t32 -183.5t-32 -183.5t-87 -136.5t-124 -86t-148 -42q-95 -10 -222 -10h-164v-496h-368zM532 782h144q71 0 98 2q72 6 111 49t39 121t-39 121t-111 49q-27 2 -98 2h-144v-344z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 1619,
    d: "M111 707q0 340 196 538.5t527 198.5t526.5 -198.5t195.5 -538.5q0 -132 -45.5 -248t-134.5 -199q107 -33 219 -125l-176 -233q-98 60 -158.5 81t-132.5 21q-64 0 -149 -18q-67 -15 -145 -15q-331 0 -527 198.5t-196 537.5zM487 707q0 -222 92.5 -343.5t254.5 -121.5 q161 0 253.5 121.5t92.5 343.5q0 223 -92 345t-254 122t-254.5 -122t-92.5 -345z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1396,
    d: "M164 0v1413h561q126 0 221 -10q81 -10 147 -34.5t120.5 -68t85 -113t30.5 -159.5q0 -269 -285 -352q106 -38 156 -118t66 -214q25 -220 106 -344h-401q-50 153 -66 283q-14 117 -59 182.5t-115 69.5q-41 2 -117 2h-82v-537h-368zM532 803h134q71 0 98 2q180 15 180 160 q0 82 -45 117t-125 42q-27 2 -98 2h-144v-323z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1282,
    d: "M70 432h368q18 -94 86 -142t158 -48q77 0 128.5 36.5t51.5 94.5q0 60 -51.5 104.5t-175.5 75.5q-103 26 -177.5 52t-140.5 64t-106 85t-63 112.5t-23 149.5q0 99 44 181t118 134.5t170 81.5t202 29q109 0 198 -23.5t151.5 -64.5t107 -100.5t69 -127.5t34.5 -149h-369 q-13 91 -62 142.5t-137 51.5q-65 0 -103 -32t-38 -95q0 -70 64.5 -115t234.5 -85q438 -104 438 -447q0 -103 -46.5 -185.5t-124.5 -134t-176.5 -79t-207.5 -27.5q-277 0 -441 115t-181 346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1294,
    d: "M29 1126v287h1286v-287h-459v-1126h-369v1126h-458z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1470,
    d: "M139 621v792h369v-860q0 -59 2 -84q15 -227 256 -227t256 227q2 25 2 84v860h369v-792q0 -101 -7 -199q-6 -93 -43 -171.5t-108.5 -142.5t-191 -100.5t-277.5 -36.5q-127 0 -230 24.5t-172.5 65.5t-118 99.5t-72 123t-28.5 138.5q-6 84 -6 199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1519,
    d: "M66 1413h401l338 -1128l340 1128h391l-510 -1413h-451z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 2080,
    d: "M53 1413h391l189 -1126l186 1106h529l178 -1110l205 1130h376l-360 -1413h-492l-178 1100l-190 -1100h-494z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1468,
    d: "M29 0l506 713l-472 700h431l266 -471l287 471h423l-493 -694l498 -719h-431l-296 477l-275 -477h-444z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1357,
    d: "M29 1413h413l279 -559l268 559h404l-498 -872v-541h-369v541z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1327,
    d: "M109 0v279l698 847h-641v287h1091v-285l-692 -841h701v-287h-1157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 839,
    d: "M223 -164v1761h559v-196h-354v-1368h354v-197h-559z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 708,
    d: "M-10 1475h215l514 -1536h-215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 839,
    d: "M57 33h355v1368h-355v196h559v-1761h-559v197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    d: "M213 440l346 822h236l346 -822h-230l-237 621l-238 -621h-223z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 1024,
    d: "M102 16h820v-196h-820v196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 614,
    d: "M-66 1425h328l187 -256h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1202,
    d: "M61 295q0 175 157.5 276t434.5 101h70v16q0 45 -4 80q-5 44 -39.5 74t-91.5 30q-64 0 -100.5 -39t-41.5 -110l-348 -2q1 124 70.5 216.5t182.5 138.5t253 46q453 0 481 -352q7 -96 7 -186v-308q0 -125 20 -276h-360l-25 160l-45 -115q-118 -74 -270 -74q-92 0 -170.5 36 t-129.5 111.5t-51 176.5zM438 324q0 -49 34 -76t91 -27q62 0 111 45t49 125v72q-27 2 -52 2q-93 1 -155 -27q-78 -34 -78 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1370,
    d: "M111 0v1505h368v-571l82 121q91 67 279 67q220 0 350.5 -152.5t130.5 -398.5q0 -142 -41.5 -257t-112.5 -189.5t-164.5 -114t-199.5 -39.5q-69 0 -140.5 15t-111.5 39l-72 116v-141h-368zM479 514q0 -152 64.5 -222.5t158.5 -70.5q111 0 176.5 85t65.5 247 q0 149 -65.5 234t-165.5 85q-109 0 -171.5 -74t-62.5 -237v-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 1202,
    d: "M49 535q0 183 77.5 318t206.5 202t292 67q234 0 377 -127.5t151 -318.5h-356q-11 102 -59 149t-122 47q-190 0 -190 -315q0 -336 195 -336q65 0 112 46.5t62 133.5h362q-30 -208 -179.5 -319t-377.5 -111q-158 0 -281.5 65t-196.5 194t-73 305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1370,
    d: "M49 522q0 142 41.5 257t112.5 189.5t164.5 114t199.5 39.5q70 0 141 -14.5t111 -38.5l72 -117v553h369v-1505h-369v160l-82 -121q-92 -68 -279 -68q-220 0 -350.5 152.5t-130.5 398.5zM426 541q0 -149 65.5 -234.5t165.5 -85.5q109 0 171.5 74t62.5 237v48 q0 152 -64.5 222t-158.5 70q-111 0 -176.5 -84.5t-65.5 -246.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1230,
    d: "M49 543q0 120 40.5 225t114 184t184.5 124.5t245 45.5q106 0 196.5 -31t154.5 -85t109.5 -125.5t67 -152.5t21.5 -167q0 -51 -6 -106h-762q13 -128 65 -181t137 -53q77 0 124.5 36.5t58.5 100.5h362q-47 -185 -192 -286t-357 -101q-119 0 -220.5 36t-178.5 105 t-120.5 179.5t-43.5 251.5zM426 680h371q-30 192 -183 192q-152 0 -188 -192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 774,
    d: "M39 856v229h117v9q0 81 2 118q13 162 127 247t358 85q64 0 123 -16v-240q-39 7 -72 7q-55 0 -96 -19q-65 -29 -72 -100q-2 -29 -2 -82v-9h224v-229h-224v-856h-368v856h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1370,
    d: "M49 539q0 142 41 254.5t112.5 183.5t164.5 108t200 37q70 0 141 -14.5t111 -38.5l72 -117v142h369v-815q0 -123 -3 -211q-9 -261 -174.5 -390t-453.5 -129q-247 0 -390 98t-163 285l-2 21h356l2 -21q6 -53 62.5 -82.5t144.5 -29.5q108 0 174.5 50.5t73.5 156.5 q4 66 4 143v31l-82 -121q-92 -68 -258 -68q-225 0 -363.5 143t-138.5 384zM426 565q0 -148 64.5 -225.5t166.5 -77.5q109 0 171.5 74t62.5 237v7q0 152 -64.5 222t-158.5 70q-242 0 -242 -307z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1318,
    d: "M111 0v1516h368v-592l99 135q104 63 245 63q168 0 266.5 -76.5t120.5 -220.5q11 -76 11 -207v-618h-369v557q0 95 -4 150q-13 165 -176 165q-89 0 -141 -88.5t-52 -267.5v-516h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 589,
    d: "M104 1358q0 83 52 131.5t139 48.5t138.5 -48.5t51.5 -131.5t-51.5 -131.5t-138.5 -48.5t-139 48.5t-52 131.5zM111 0v1094h368v-1094h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 577,
    d: "M-102 -174q29 -3 54 -3q62 0 96 17q47 22 54 92q4 58 4 99v1063h369v-1061q0 -57 -4 -131q-11 -162 -117 -247t-334 -85q-73 0 -122 8v248zM100 1358q0 95 46 137.5t145 42.5t144.5 -42.5t45.5 -137.5t-45.5 -137.5t-144.5 -42.5t-145 42.5t-46 137.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 1294,
    d: "M111 0v1505h368v-870l385 459h432l-462 -502l469 -592h-453l-293 406l-78 -87v-319h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 624,
    d: "M102 387v1118h369v-1112q0 -73 4 -100q5 -34 28 -45q18 -9 65 -9q13 0 28 1v-250q-113 -10 -215 -10q-263 0 -275 213q-4 57 -4 194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1978,
    d: "M111 0v1094h368v-176l88 141q104 63 236 63q134 0 223.5 -58.5t126.5 -154.5l115 150q104 63 235 63q157 0 252 -78t115 -198q10 -69 10 -207v-639h-369v557q0 77 -8 150q-19 165 -157 165q-166 0 -166 -294v-578h-369v557q0 77 -8 150q-19 165 -158 165 q-166 0 -166 -294v-578h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1318,
    d: "M111 0v1094h368v-170l99 135q104 63 245 63q168 0 266.5 -76.5t120.5 -220.5q11 -76 11 -207v-618h-369v557q0 95 -4 150q-13 165 -176 165q-89 0 -141 -88.5t-52 -267.5v-516h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1273,
    d: "M49 547q0 264 159.5 419.5t428.5 155.5t428.5 -155.5t159.5 -419.5q0 -263 -160 -419.5t-428 -156.5t-428 156.5t-160 419.5zM426 547q0 -160 55.5 -243t155.5 -83t155.5 83t55.5 243q0 161 -55.5 243t-155.5 82t-155.5 -82t-55.5 -243z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1370,
    d: "M111 -401v1495h368v-160l82 121q91 67 279 67q220 0 350.5 -152.5t130.5 -398.5q0 -142 -41.5 -257t-112.5 -189.5t-164.5 -114t-199.5 -39.5q-69 0 -140.5 15t-111.5 39l-72 116v-542h-368zM479 514q0 -152 64.5 -222.5t158.5 -70.5q111 0 176.5 85t65.5 247 q0 149 -65.5 234t-165.5 85q-109 0 -171.5 -74t-62.5 -237v-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1370,
    d: "M49 522q0 142 41.5 257t112.5 189.5t164.5 114t199.5 39.5q70 0 141 -14.5t111 -38.5l72 -117v142h369v-1495h-369v561l-82 -121q-92 -68 -279 -68q-220 0 -350.5 152.5t-130.5 398.5zM426 541q0 -149 65.5 -234.5t165.5 -85.5q109 0 171.5 74t62.5 237v48 q0 152 -64.5 222t-158.5 70q-111 0 -176.5 -84.5t-65.5 -246.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 860,
    d: "M111 0v1094h368v-222l78 154q42 47 100.5 71.5t114.5 24.5q44 0 84 -6v-301q-28 2 -54 2q-167 0 -239 -79q-84 -91 -84 -337v-401h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 1081,
    d: "M37 340h362q15 -63 60 -101t104 -38q52 0 84.5 21.5t32.5 62.5q0 52 -58.5 85.5t-205.5 67.5q-164 38 -249 117.5t-85 214.5q0 162 130 257t349 95q197 0 316.5 -96.5t142.5 -251.5h-363q-25 119 -118 119q-38 0 -63 -22.5t-25 -57.5q0 -48 54 -82.5t204 -71.5 q80 -20 138 -46t105.5 -66t72 -98.5t24.5 -135.5q0 -112 -67 -191t-174 -115t-243 -36q-228 0 -367.5 94t-160.5 275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 819,
    d: "M10 856v229h174v283h369v-283h242v-229h-242v-403q0 -78 2 -107q6 -84 47 -108q33 -20 123 -20q22 0 47 1v-229q-114 -19 -217 -19q-197 0 -277.5 60t-89.5 192q-4 63 -4 176v457h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1310,
    d: "M90 455v639h369v-557q0 -77 8 -150q9 -82 51 -124t127 -42q86 0 136 71.5t50 182.5v619h369v-1094h-369v184l-98 -149q-106 -64 -246 -64q-162 0 -264.5 79t-122.5 198q-10 69 -10 207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 1245,
    d: "M0 1094h410l225 -801l223 801h404l-433 -1094h-397z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1777,
    d: "M0 1094h406l143 -783l131 774h438l139 -776l140 785h397l-346 -1094h-412l-139 737l-139 -737h-412z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 1208,
    d: "M-2 0l381 555l-367 539h430l172 -316l168 316h424l-372 -543l376 -551h-430l-174 330l-184 -330h-424z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 1245,
    d: "M0 1094h410l225 -801l223 801h404l-433 -1094q-52 -132 -101.5 -213.5t-111 -131t-132 -67.5t-171.5 -18q-89 0 -155 10v238q31 -4 100 -4q67 0 111 24.5t69 81.5l15 31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 1077,
    d: "M70 0v215l553 641h-523v229h912v-225l-547 -631h553v-229h-948z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 880,
    d: "M231 618v197q168 10 168 117q0 61 -18 184q-25 166 -25 244q0 124 63 180.5t214 56.5h104v-196h-45q-78 0 -104.5 -15t-26.5 -67q0 -36 21 -182q22 -145 22 -211q0 -85 -42.5 -134.5t-131.5 -68.5q174 -42 174 -215q0 -66 -22 -211q-21 -146 -21 -182q0 -52 26.5 -67 t104.5 -15h45v-197h-104q-151 0 -214 57t-63 181q0 77 25 243q18 123 18 185q0 48 -36 79.5t-132 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 638,
    d: "M201 -410v2048h237v-2048h-237z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 880,
    d: "M143 33h45q78 0 104.5 15t26.5 67q0 43 -20 182q-23 151 -23 211q0 85 43 134.5t132 68.5q-175 43 -175 215q0 60 23 211q20 139 20 182q0 52 -26.5 67t-104.5 15h-45v196h105q151 0 213.5 -56.5t62.5 -180.5q0 -85 -24 -244q-19 -130 -19 -184q0 -107 168 -117v-197 q-96 -5 -132 -36.5t-36 -79.5q0 -55 19 -185q24 -159 24 -243q0 -124 -62.5 -181t-213.5 -57h-105v197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    d: "M178 457q0 374 271 374q63 0 118 -19.5t140 -63.5q78 -42 114.5 -57t69.5 -15q47 0 69.5 35t22.5 120h197q0 -374 -271 -374q-61 0 -114.5 19t-143.5 65q-80 42 -117 56.5t-67 14.5q-51 0 -71.5 -37.5t-20.5 -117.5h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 573,
    d: "M102 932q0 81 51.5 131.5t133.5 50.5t133 -50t51 -132t-51 -133t-133 -51t-133.5 51t-51.5 133zM121 -328l24 983h283l25 -983h-332z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    d: "M129 530q0 240 127.5 390.5t333.5 183.5v166h205v-162q196 -24 313 -146.5t125 -293.5h-315q-13 126 -123 176v-600q104 53 120 157h322q-26 -181 -142.5 -288.5t-299.5 -132.5v-164h-205v161q-205 28 -333 177t-128 376zM465 553q0 -225 125 -301v584 q-58 -34 -91.5 -106t-33.5 -177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    d: "M127 0v254q205 36 205 217q0 57 -19 121h-168v180h93q-45 113 -45 227q0 207 140 325t372 118q125 0 222.5 -35.5t156.5 -97.5t91.5 -137t38.5 -162h-368q-5 72 -40.5 116.5t-100.5 44.5q-56 0 -91.5 -41.5t-35.5 -105.5q0 -60 12 -113t47 -139h397v-180h-336 q7 -47 7 -78q0 -70 -41 -130.5t-115 -96.5h680v-287h-1102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    d: "M258 315l107 107q-56 88 -56 194q0 107 56 195l-107 107l117 116l106 -106q85 57 197 57q111 0 196 -57l107 106l117 -116l-107 -107q56 -88 56 -195q0 -106 -56 -194l107 -107l-117 -116l-107 106q-85 -57 -196 -57q-112 0 -197 57l-106 -106zM522 616q0 -80 43 -128 t113 -48t113 48t43 128t-43 128.5t-113 48.5t-113 -48.5t-43 -128.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    d: "M49 1413h381l256 -614l250 614h371l-353 -635h215v-196h-307v-117h307v-197h-307v-268h-368v268h-308v197h308v117h-308v196h215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 606,
    d: "M201 -328v697h205v-697h-205zM201 717v696h205v-696h-205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 1290,
    d: "M45 606q0 189 156 297q-31 60 -31 131q0 180 132.5 294t348.5 114q198 0 316.5 -99t140.5 -266h-363q-12 70 -38.5 102.5t-75.5 32.5q-40 0 -66 -30t-26 -84q0 -80 49 -120.5t203 -80.5q236 -63 344 -160t108 -258q0 -200 -172 -301q45 -65 45 -162q0 -172 -138 -272 t-351 -100q-220 0 -361 94t-162 274h363q15 -63 60 -101t104 -38q52 0 84.5 28.5t32.5 80.5q0 69 -65.5 119.5t-250.5 107.5q-99 31 -165.5 62.5t-119.5 77.5t-77.5 109t-24.5 148zM414 618q0 -63 48.5 -103t158.5 -77q140 -47 213 -82q40 32 40 90q0 69 -52.5 115 t-180.5 82q-105 28 -197 68q-30 -30 -30 -93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 614,
    d: "M-51 1315q0 69 42 109t111 40q70 0 112 -40.5t42 -108.5q0 -69 -42.5 -109.5t-111.5 -40.5t-111 40.5t-42 109.5zM358 1315q0 68 42 108.5t112 40.5t112 -40.5t42 -108.5q0 -69 -42.5 -109.5t-111.5 -40.5t-111.5 40.5t-42.5 109.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 1761,
    d: "M33 727q0 239 108 428t301.5 294t438.5 105t438.5 -105t301.5 -294t108 -428t-108 -428t-301.5 -294t-438.5 -105t-438.5 105t-301.5 294t-108 428zM254 727q0 -275 176 -451t451 -176t450.5 176t175.5 451q0 277 -175.5 454t-450.5 177t-451 -177t-176 -454zM428 727 q0 210 129 337.5t342 127.5q194 0 306 -104t126 -281h-301q-13 176 -143 176q-77 0 -110.5 -64.5t-33.5 -189.5q0 -262 152 -262q56 0 92.5 42.5t40.5 133.5h301q-26 -180 -138 -282.5t-306 -102.5q-206 0 -331.5 125.5t-125.5 343.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 1427,
    d: "M301 508l281 340h264l-281 -340l281 -340h-264zM793 508l280 340h264l-280 -340l280 -340h-264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    d: "M246 618v197h844v-463h-205v266h-639z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 643,
    d: "M66 481v197h512v-197h-512z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 995,
    d: "M68 1135q0 189 120 309.5t310 120.5t310 -120.5t120 -309.5t-120 -309.5t-310 -120.5t-310 120.5t-120 309.5zM190 1135q0 -138 86.5 -227t221.5 -89t221 89t86 227t-86 226.5t-221 88.5t-221.5 -88.5t-86.5 -226.5zM332 928v438h157q38 0 56 -2q72 -7 107.5 -40 t35.5 -85q0 -41 -22 -68t-58 -38q51 -16 58 -95q7 -67 26 -110h-137q-7 28 -14 84q-9 59 -60 59h-26v-143h-123zM455 1165h18q27 0 41 2q19 3 30 18t11 34q0 46 -41 53q-14 2 -39 2h-20v-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 614,
    d: "M0 1200v197h614v-197h-614z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 655,
    d: "M41 1165q0 122 80.5 199.5t206.5 77.5t206 -77.5t80 -199.5t-80 -199t-206 -77t-206.5 77.5t-80.5 198.5zM233 1165q0 -41 28.5 -68.5t66.5 -27.5t66 27t28 69t-28 69.5t-66 27.5t-66.5 -27.5t-28.5 -69.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    d: "M268 0v180h819v-180h-819zM268 553v197h307v290h205v-290h307v-197h-307v-295h-205v295h-307z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 614,
    d: "M197 1169l186 256h328l-318 -256h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 1265,
    d: "M78 1034q0 153 85 260.5t236 116.5q35 2 115 2h641v-1638h-205v1442h-231v-1442h-205v880q-80 0 -115 2q-151 9 -236 116.5t-85 260.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 573,
    d: "M82 625q0 91 57 147.5t148 56.5t148 -56.5t57 -147.5t-57 -148t-148 -57t-148 57t-57 148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 614,
    d: "M78 -274q64 -15 119 -15q122 0 122 56q0 33 -44 46.5t-154 6.5l96 198h180l-51 -104q195 -21 195 -158q0 -51 -27 -88t-76 -58t-109 -30.5t-134 -9.5q-70 0 -117 12v144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 1359,
    d: "M90 168l281 340l-281 340h264l281 -340l-281 -340h-264zM582 168l280 340l-280 340h264l280 -340l-280 -340h-264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 1144,
    d: "M98 47q0 118 50 199t167 176q81 66 113 115t41 127h299q-3 -119 -33 -189t-100 -145q-85 -90 -118.5 -144.5t-33.5 -107.5q0 -156 144 -156q140 0 149 201h369q-6 -221 -151.5 -346t-393.5 -125q-237 0 -369.5 103.5t-132.5 291.5zM430 940q0 82 51 132t133 50 t133.5 -50.5t51.5 -131.5q0 -82 -51.5 -133t-133.5 -51t-133 51t-51 133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 1447,
    d: "M8 0l510 1413h451l510 -1413h-402l-119 367h-440l-119 -367h-391zM354 1761h328l186 -256h-196zM608 653h262l-131 434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 1447,
    d: "M8 0l510 1413h451l510 -1413h-402l-119 367h-440l-119 -367h-391zM608 653h262l-131 434zM633 1505l186 256h328l-318 -256h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 1447,
    d: "M8 0l510 1413h451l510 -1413h-402l-119 367h-440l-119 -367h-391zM465 1505l127 256h305l127 -256h-213l-70 156l-65 -156h-211zM608 653h262l-131 434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 1447,
    d: "M8 0l510 1413h451l510 -1413h-402l-119 367h-440l-119 -367h-391zM408 1520q0 142 44.5 208t139.5 66q46 0 80 -7.5t88 -31.5q66 -31 92 -31q17 0 24 15t7 49h196q0 -142 -44.5 -208.5t-139.5 -66.5q-46 0 -79.5 7.5t-88.5 31.5q-76 31 -92 31q-17 0 -24 -14.5t-7 -48.5 h-196zM608 653h262l-131 434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 1447,
    d: "M8 0l510 1413h451l510 -1413h-402l-119 367h-440l-119 -367h-391zM385 1628q0 69 42.5 109.5t111.5 40.5t111 -40.5t42 -109.5t-42 -109t-111 -40q-70 0 -112 40.5t-42 108.5zM608 653h262l-131 434zM795 1628q0 69 42 109.5t111 40.5t111.5 -40.5t42.5 -109.5 q0 -68 -42 -108.5t-112 -40.5q-69 0 -111 40t-42 109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 1447,
    d: "M8 0l510 1413h451l510 -1413h-402l-119 367h-440l-119 -367h-391zM500 1694q0 95 68 155t175 60t175.5 -60t68.5 -155t-68.5 -155t-175.5 -60t-175 60t-68 155zM608 653h262l-131 434zM670 1694q0 -35 20.5 -57.5t52.5 -22.5t53 22.5t21 57.5t-21 57.5t-53 22.5 t-52.5 -22.5t-20.5 -57.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 2039,
    d: "M-86 0l735 1413h1309v-287h-748l-12 21l35 -295h684v-287h-651l32 -278h680v-287h-1015l-50 428h-405l-203 -428h-391zM645 715h236l-47 397z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 1503,
    d: "M111 696q0 180 55 323.5t150.5 235t221.5 139.5t271 48q147 0 265 -37.5t195.5 -105t122.5 -156.5t56 -195l2 -20h-369l-4 20q-45 223 -272 223q-138 0 -223.5 -116t-85.5 -336q0 -104 17 -186t45.5 -136t68.5 -89.5t84.5 -50.5t95.5 -15q107 0 175 62.5t91 180.5l4 21 h369l-2 -21q-24 -238 -185.5 -369.5t-416.5 -142.5l-29 -59q195 -21 195 -158q0 -51 -27 -88t-76 -58t-109 -30.5t-134 -9.5q-70 0 -117 12v144q64 -15 119 -15q122 0 122 56q0 33 -44 46.5t-154 6.5l78 162q-120 19 -220.5 73.5t-175.5 142.5t-117 215.5t-42 282.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 1308,
    d: "M164 0v1413h1063v-287h-695v-274h654v-287h-654v-278h715v-287h-1083zM307 1761h328l186 -256h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 1308,
    d: "M164 0v1413h1063v-287h-695v-274h654v-287h-654v-278h715v-287h-1083zM586 1505l186 256h328l-318 -256h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 1308,
    d: "M164 0v1413h1063v-287h-695v-274h654v-287h-654v-278h715v-287h-1083zM418 1505l127 256h305l127 -256h-213l-70 156l-65 -156h-211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 1308,
    d: "M164 0v1413h1063v-287h-695v-274h654v-287h-654v-278h715v-287h-1083zM338 1628q0 69 42.5 109.5t111.5 40.5t111 -40.5t42 -109.5t-42 -109t-111 -40q-70 0 -112 40.5t-42 108.5zM748 1628q0 69 42 109.5t111 40.5t111.5 -40.5t42.5 -109.5q0 -68 -42 -108.5t-112 -40.5 q-69 0 -111 40t-42 109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 643,
    d: "M-41 1761h328l186 -256h-197zM164 0v1413h368v-1413h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 643,
    d: "M164 0v1413h368v-1413h-368zM238 1505l186 256h328l-318 -256h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 643,
    d: "M70 1505l127 256h305l127 -256h-213l-70 156l-65 -156h-211zM164 0v1413h368v-1413h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 643,
    d: "M-10 1628q0 69 42 109.5t111 40.5t111.5 -40.5t42.5 -109.5q0 -68 -42 -108.5t-112 -40.5q-69 0 -111 40t-42 109zM164 0v1413h368v-1413h-368zM399 1628q0 69 42.5 109.5t111.5 40.5t111.5 -40.5t42.5 -109.5q0 -68 -42 -108.5t-112 -40.5t-112 40.5t-42 108.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 1554,
    d: "M63 600v197h121v616h535q108 0 180 -8q127 -14 232.5 -60.5t189 -127t130 -206t46.5 -286.5t-47 -292.5t-129.5 -219t-189.5 -139.5t-232 -66q-72 -8 -180 -8h-535v600h-121zM553 287h115q86 0 133 4q140 12 225.5 127t85.5 301q0 184 -84 287.5t-227 115.5q-47 4 -133 4 h-115v-329h209v-197h-209v-313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 1626,
    d: "M164 0v1413h459l536 -975q-12 172 -12 371v604h369v-1413h-482l-514 934q12 -143 12 -350v-584h-368zM494 1520q0 142 44.5 208t139.5 66q46 0 80 -7.5t88 -31.5q66 -31 92 -31q17 0 24 15t7 49h196q0 -142 -44.5 -208.5t-139.5 -66.5q-46 0 -79.5 7.5t-88.5 31.5 q-76 31 -92 31q-17 0 -24 -14.5t-7 -48.5h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 1613,
    d: "M111 707q0 340 196 537.5t527 197.5t526.5 -197.5t195.5 -537.5q0 -339 -195.5 -537.5t-526.5 -198.5t-527 198.5t-196 537.5zM444 1761h328l186 -256h-196zM487 707q0 -222 92.5 -343.5t254.5 -121.5q161 0 253.5 121.5t92.5 343.5q0 223 -92 343.5t-254 120.5 t-254.5 -120.5t-92.5 -343.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 1613,
    d: "M111 707q0 340 196 537.5t527 197.5t526.5 -197.5t195.5 -537.5q0 -339 -195.5 -537.5t-526.5 -198.5t-527 198.5t-196 537.5zM487 707q0 -222 92.5 -343.5t254.5 -121.5q161 0 253.5 121.5t92.5 343.5q0 223 -92 343.5t-254 120.5t-254.5 -120.5t-92.5 -343.5zM723 1505 l186 256h328l-317 -256h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 1613,
    d: "M111 707q0 340 196 537.5t527 197.5t526.5 -197.5t195.5 -537.5q0 -339 -195.5 -537.5t-526.5 -198.5t-527 198.5t-196 537.5zM487 707q0 -222 92.5 -343.5t254.5 -121.5q161 0 253.5 121.5t92.5 343.5q0 223 -92 343.5t-254 120.5t-254.5 -120.5t-92.5 -343.5zM555 1505 l127 256h305l127 -256h-213l-70 156l-65 -156h-211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 1613,
    d: "M111 707q0 340 196 537.5t527 197.5t526.5 -197.5t195.5 -537.5q0 -339 -195.5 -537.5t-526.5 -198.5t-527 198.5t-196 537.5zM487 707q0 -222 92.5 -343.5t254.5 -121.5q161 0 253.5 121.5t92.5 343.5q0 223 -92 343.5t-254 120.5t-254.5 -120.5t-92.5 -343.5zM498 1520 q0 142 44.5 208t139.5 66q46 0 80 -7.5t88 -31.5q66 -31 92 -31q17 0 24 15t7 49h196q0 -142 -44.5 -208.5t-139.5 -66.5q-46 0 -79.5 7.5t-88.5 31.5q-76 31 -92 31q-17 0 -24 -14.5t-7 -48.5h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 1613,
    d: "M111 707q0 340 196 537.5t527 197.5t526.5 -197.5t195.5 -537.5q0 -339 -195.5 -537.5t-526.5 -198.5t-527 198.5t-196 537.5zM475 1628q0 69 42.5 109.5t111.5 40.5t111 -40.5t42 -109.5t-42 -109t-111 -40q-70 0 -112 40.5t-42 108.5zM487 707q0 -222 92.5 -343.5 t254.5 -121.5q161 0 253.5 121.5t92.5 343.5q0 223 -92 343.5t-254 120.5t-254.5 -120.5t-92.5 -343.5zM885 1628q0 69 42 109.5t111 40.5t111.5 -40.5t42.5 -109.5q0 -68 -42 -108.5t-112 -40.5q-69 0 -111 40t-42 109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    d: "M219 358l316 316l-316 315l143 144l316 -316l315 316l144 -144l-316 -315l316 -316l-144 -143l-315 315l-316 -315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 1617,
    d: "M102 117l138 137q-127 184 -127 453q0 340 196 537.5t527 197.5q270 0 456 -135l133 133l144 -144l-137 -137q127 -184 127 -452q0 -339 -196 -537.5t-527 -198.5q-273 0 -455 138l-135 -136zM489 707q0 -103 21 -183l555 555q-86 92 -229 92q-162 0 -254.5 -120.5 t-92.5 -343.5zM606 334q86 -92 230 -92q161 0 253.5 121.5t92.5 343.5q0 103 -21 182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 1470,
    d: "M139 621v792h369v-860q0 -59 2 -84q15 -227 256 -227t256 227q2 25 2 84v860h369v-792q0 -101 -7 -199q-6 -93 -43 -171.5t-108.5 -142.5t-191 -100.5t-277.5 -36.5q-127 0 -230 24.5t-172.5 65.5t-118 99.5t-72 123t-28.5 138.5q-6 84 -6 199zM377 1761h328l186 -256 h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 1470,
    d: "M139 621v792h369v-860q0 -59 2 -84q15 -227 256 -227t256 227q2 25 2 84v860h369v-792q0 -101 -7 -199q-6 -93 -43 -171.5t-108.5 -142.5t-191 -100.5t-277.5 -36.5q-127 0 -230 24.5t-172.5 65.5t-118 99.5t-72 123t-28.5 138.5q-6 84 -6 199zM655 1505l187 256h327 l-317 -256h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 1470,
    d: "M139 621v792h369v-860q0 -59 2 -84q15 -227 256 -227t256 227q2 25 2 84v860h369v-792q0 -101 -7 -199q-6 -93 -43 -171.5t-108.5 -142.5t-191 -100.5t-277.5 -36.5q-127 0 -230 24.5t-172.5 65.5t-118 99.5t-72 123t-28.5 138.5q-6 84 -6 199zM487 1505l127 256h306 l127 -256h-213l-70 156l-66 -156h-211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 1470,
    d: "M139 621v792h369v-860q0 -59 2 -84q15 -227 256 -227t256 227q2 25 2 84v860h369v-792q0 -101 -7 -199q-6 -93 -43 -171.5t-108.5 -142.5t-191 -100.5t-277.5 -36.5q-127 0 -230 24.5t-172.5 65.5t-118 99.5t-72 123t-28.5 138.5q-6 84 -6 199zM408 1628q0 69 42 109.5 t111 40.5t111.5 -40.5t42.5 -109.5q0 -68 -42 -108.5t-112 -40.5q-69 0 -111 40t-42 109zM817 1628q0 69 42.5 109.5t111.5 40.5t111 -40.5t42 -109.5t-42 -109t-111 -40q-70 0 -112 40.5t-42 108.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 1357,
    d: "M29 1413h413l279 -559l268 559h404l-498 -872v-541h-369v541zM600 1505l186 256h328l-317 -256h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 1337,
    d: "M164 0v1413h368v-180h183q126 0 221 -10q165 -20 269 -127.5t104 -300.5t-104 -300.5t-269 -127.5q-104 -11 -221 -11h-183v-356h-368zM532 643h144q71 0 98 2q150 13 150 150q0 136 -150 149q-27 2 -98 2h-144v-303z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 1363,
    d: "M111 0v881q0 139 4 213q14 212 163.5 331t407.5 119q256 0 400.5 -108.5t144.5 -288.5q0 -95 -53 -172q-61 -35 -87 -72.5t-26 -87.5q0 -40 23 -80.5t75 -95.5q59 -63 87 -102.5t44.5 -94t16.5 -131.5q0 -104 -59.5 -178t-150 -107.5t-200.5 -33.5q-183 0 -283 20v277 q106 -27 193 -27q55 0 85 25t30 71q0 75 -90 168q-89 93 -122.5 150t-33.5 139q0 150 139 238q27 36 27 90q0 131 -172 131q-89 0 -137 -48t-54 -136q-4 -58 -4 -193v-897h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 1202,
    d: "M61 295q0 175 157.5 276t434.5 101h70v16q0 45 -4 80q-5 44 -39.5 74t-91.5 30q-64 0 -100.5 -39t-41.5 -110l-348 -2q1 124 70.5 216.5t182.5 138.5t253 46q453 0 481 -352q7 -96 7 -186v-308q0 -125 20 -276h-360l-25 160l-45 -115q-118 -74 -270 -74q-92 0 -170.5 36 t-129.5 111.5t-51 176.5zM227 1425h328l186 -256h-196zM438 324q0 -49 34 -76t91 -27q62 0 111 45t49 125v72q-130 9 -207.5 -25.5t-77.5 -113.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 1202,
    d: "M61 295q0 175 157.5 276t434.5 101h70v16q0 45 -4 80q-5 44 -39.5 74t-91.5 30q-64 0 -100.5 -39t-41.5 -110l-348 -2q1 124 70.5 216.5t182.5 138.5t253 46q453 0 481 -352q7 -96 7 -186v-308q0 -125 20 -276h-360l-25 160l-45 -115q-118 -74 -270 -74q-92 0 -170.5 36 t-129.5 111.5t-51 176.5zM438 324q0 -49 34 -76t91 -27q62 0 111 45t49 125v72q-130 9 -207.5 -25.5t-77.5 -113.5zM489 1169l187 256h328l-318 -256h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 1202,
    d: "M61 295q0 175 157.5 276t434.5 101h70v16q0 45 -4 80q-5 44 -39.5 74t-91.5 30q-64 0 -100.5 -39t-41.5 -110l-348 -2q1 124 70.5 216.5t182.5 138.5t253 46q453 0 481 -352q7 -96 7 -186v-308q0 -125 20 -276h-360l-25 160l-45 -115q-118 -74 -270 -74q-92 0 -170.5 36 t-129.5 111.5t-51 176.5zM322 1169l127 256h305l127 -256h-213l-70 156l-66 -156h-210zM438 324q0 -49 34 -76t91 -27q62 0 111 45t49 125v72q-130 9 -207.5 -25.5t-77.5 -113.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 1202,
    d: "M61 295q0 175 157.5 276t434.5 101h70v16q0 45 -4 80q-5 44 -39.5 74t-91.5 30q-64 0 -100.5 -39t-41.5 -110l-348 -2q1 124 70.5 216.5t182.5 138.5t253 46q453 0 481 -352q7 -96 7 -186v-308q0 -125 20 -276h-360l-25 160l-45 -115q-118 -74 -270 -74q-92 0 -170.5 36 t-129.5 111.5t-51 176.5zM264 1176q0 142 45 208t140 66q46 0 79.5 -7.5t87.5 -31.5q66 -31 93 -31q17 0 23.5 14.5t6.5 49.5h197q0 -142 -44.5 -208.5t-139.5 -66.5q-46 0 -79.5 7.5t-88.5 31.5q-76 31 -92 31q-17 0 -24 -14.5t-7 -48.5h-197zM438 324q0 -49 34 -76t91 -27 q62 0 111 45t49 125v72q-130 9 -207.5 -25.5t-77.5 -113.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 1202,
    d: "M61 295q0 175 157.5 276t434.5 101h70v16q0 45 -4 80q-5 44 -39.5 74t-91.5 30q-64 0 -100.5 -39t-41.5 -110l-348 -2q1 124 70.5 216.5t182.5 138.5t253 46q453 0 481 -352q7 -96 7 -186v-308q0 -125 20 -276h-360l-25 160l-45 -115q-118 -74 -270 -74q-92 0 -170.5 36 t-129.5 111.5t-51 176.5zM242 1315q0 69 42 109t111 40q70 0 112 -40.5t42 -108.5q0 -69 -42.5 -109.5t-111.5 -40.5t-111 40.5t-42 109.5zM438 324q0 -49 34 -76t91 -27q62 0 111 45t49 125v72q-130 9 -207.5 -25.5t-77.5 -113.5zM651 1315q0 68 42 108.5t112 40.5 q69 0 111 -40t42 -109t-42 -109.5t-111 -40.5t-111.5 40.5t-42.5 109.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 1202,
    d: "M61 295q0 175 157.5 276t434.5 101h70v16q0 45 -4 80q-5 44 -39.5 74t-91.5 30q-64 0 -100.5 -39t-41.5 -110l-348 -2q1 124 70.5 216.5t182.5 138.5t253 46q453 0 481 -352q7 -96 7 -186v-308q0 -125 20 -276h-360l-25 160l-45 -115q-118 -74 -270 -74q-92 0 -170.5 36 t-129.5 111.5t-51 176.5zM356 1380q0 98 68 158.5t176 60.5t176 -60.5t68 -158.5t-68 -158.5t-176 -60.5t-176 60.5t-68 158.5zM438 324q0 -49 34 -76t91 -27q62 0 111 45t49 125v72q-130 9 -207.5 -25.5t-77.5 -113.5zM526 1380q0 -39 20.5 -61.5t53.5 -22.5t53.5 22.5 t20.5 61.5t-20.5 61.5t-53.5 22.5t-53.5 -22.5t-20.5 -61.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 1994,
    d: "M61 305q0 182 160.5 278.5t431.5 96.5h119v12q0 180 -164 180q-67 0 -112.5 -40.5t-49.5 -110.5h-348q1 124 70.5 216.5t182.5 138.5t253 46q295 0 391 -190q66 94 176 142t246 48q125 0 227 -47.5t167 -127t100 -179t35 -207.5q0 -41 -7 -106h-761q13 -128 65 -181 t137 -53q77 0 124.5 36.5t58.5 100.5h362q-47 -185 -192 -286t-357 -101q-314 0 -456 234l-136 -160q-118 -74 -290 -74q-201 0 -317 86t-116 248zM438 334q0 -113 148 -113q86 0 137 57t51 160v17q-175 9 -255.5 -20t-80.5 -101zM1190 680h371q-13 95 -60 143.5t-123 48.5 q-149 0 -188 -192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 1202,
    d: "M49 535q0 183 77.5 318t206.5 202t292 67q234 0 377 -127.5t151 -318.5h-356q-11 102 -59 149t-122 47q-190 0 -190 -315q0 -336 195 -336q65 0 112 46.5t62 133.5h362q-27 -191 -157 -300.5t-332 -127.5l-29 -59q195 -21 195 -158q0 -51 -27 -88t-76.5 -58t-109.5 -30.5 t-134 -9.5q-69 0 -116 12v144q64 -15 118 -15q123 0 123 56q0 33 -44 46.5t-154 6.5l78 160q-200 33 -321.5 178.5t-121.5 376.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 1230,
    d: "M49 543q0 120 40.5 225t114 184t184.5 124.5t245 45.5q106 0 196.5 -31t154.5 -85t109.5 -125.5t67 -152.5t21.5 -167q0 -51 -6 -106h-762q13 -128 65 -181t137 -53q77 0 124.5 36.5t58.5 100.5h362q-47 -185 -192 -286t-357 -101q-119 0 -220.5 36t-178.5 105 t-120.5 179.5t-43.5 251.5zM246 1425h327l187 -256h-197zM426 680h371q-30 192 -183 192q-152 0 -188 -192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 1230,
    d: "M49 543q0 120 40.5 225t114 184t184.5 124.5t245 45.5q106 0 196.5 -31t154.5 -85t109.5 -125.5t67 -152.5t21.5 -167q0 -51 -6 -106h-762q13 -128 65 -181t137 -53q77 0 124.5 36.5t58.5 100.5h362q-47 -185 -192 -286t-357 -101q-119 0 -220.5 36t-178.5 105 t-120.5 179.5t-43.5 251.5zM426 680h371q-30 192 -183 192q-152 0 -188 -192zM508 1169l186 256h328l-317 -256h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 1230,
    d: "M49 543q0 120 40.5 225t114 184t184.5 124.5t245 45.5q106 0 196.5 -31t154.5 -85t109.5 -125.5t67 -152.5t21.5 -167q0 -51 -6 -106h-762q13 -128 65 -181t137 -53q77 0 124.5 36.5t58.5 100.5h362q-47 -185 -192 -286t-357 -101q-119 0 -220.5 36t-178.5 105 t-120.5 179.5t-43.5 251.5zM340 1169l127 256h305l127 -256h-213l-70 156l-65 -156h-211zM426 680h371q-30 192 -183 192q-152 0 -188 -192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 1230,
    d: "M49 543q0 120 40.5 225t114 184t184.5 124.5t245 45.5q106 0 196.5 -31t154.5 -85t109.5 -125.5t67 -152.5t21.5 -167q0 -51 -6 -106h-762q13 -128 65 -181t137 -53q77 0 124.5 36.5t58.5 100.5h362q-47 -185 -192 -286t-357 -101q-119 0 -220.5 36t-178.5 105 t-120.5 179.5t-43.5 251.5zM260 1315q0 68 42 108.5t112 40.5q69 0 111 -40t42 -109t-42 -109.5t-111 -40.5t-111.5 40.5t-42.5 109.5zM426 680h371q-30 192 -183 192q-152 0 -188 -192zM670 1315q0 69 42 109t111 40q70 0 112 -40.5t42 -108.5q0 -69 -42.5 -109.5 t-111.5 -40.5t-111 40.5t-42 109.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 589,
    d: "M-78 1425h328l186 -256h-196zM111 0v1094h368v-1094h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 589,
    d: "M111 0v1094h368v-1094h-368zM184 1169l187 256h327l-317 -256h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 589,
    d: "M16 1169l127 256h306l126 -256h-213l-69 156l-66 -156h-211zM111 0v1094h368v-1094h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 589,
    d: "M-63 1315q0 69 42 109t111 40q70 0 112 -40.5t42 -108.5q0 -69 -42.5 -109.5t-111.5 -40.5t-111 40.5t-42 109.5zM111 0v1094h368v-1094h-368zM346 1315q0 68 42 108.5t112 40.5q69 0 111 -40t42 -109t-42 -109.5t-111 -40.5t-111.5 40.5t-42.5 109.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    d: "M49 547q0 137 42 247.5t115.5 181.5t171.5 108.5t212 37.5q88 0 188 -59l88 -111q-16 132 -102 240l-254 -47l-25 149l133 25q-46 32 -135 72l318 135q124 -56 213 -133l176 32l24 -149l-86 -16q140 -216 140 -631q0 -142 -35.5 -256.5t-93.5 -188t-137 -123t-161.5 -70 t-170.5 -20.5q-154 0 -273 42t-194.5 119t-114.5 182t-39 233zM434 547q0 -155 61.5 -230t174.5 -75q112 0 166.5 78.5t54.5 211.5v60q0 117 -59.5 188.5t-159.5 71.5q-118 0 -178 -80.5t-60 -224.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 1318,
    d: "M111 0v1094h368v-170l99 135q104 63 245 63q168 0 266.5 -76.5t120.5 -220.5q11 -76 11 -207v-618h-369v557q0 95 -4 150q-13 165 -176 165q-89 0 -141 -88.5t-52 -267.5v-516h-368zM322 1176q0 142 44.5 208t139.5 66q46 0 80 -7.5t88 -31.5q66 -31 92 -31q17 0 24 15 t7 49h196q0 -142 -44.5 -208.5t-139.5 -66.5q-46 0 -79.5 7.5t-88.5 31.5q-76 31 -92 31q-17 0 -24 -14.5t-7 -48.5h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 1273,
    d: "M49 547q0 264 159.5 419.5t428.5 155.5t428.5 -155.5t159.5 -419.5q0 -263 -160 -419.5t-428 -156.5t-428 156.5t-160 419.5zM264 1425h328l186 -256h-196zM426 547q0 -160 55.5 -243t155.5 -83t155.5 83t55.5 243q0 161 -55.5 243t-155.5 82t-155.5 -82t-55.5 -243z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 1273,
    d: "M49 547q0 264 159.5 419.5t428.5 155.5t428.5 -155.5t159.5 -419.5q0 -263 -160 -419.5t-428 -156.5t-428 156.5t-160 419.5zM426 547q0 -160 55.5 -243t155.5 -83t155.5 83t55.5 243q0 161 -55.5 243t-155.5 82t-155.5 -82t-55.5 -243zM526 1169l187 256h327l-317 -256 h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 1273,
    d: "M49 547q0 264 159.5 419.5t428.5 155.5t428.5 -155.5t159.5 -419.5q0 -263 -160 -419.5t-428 -156.5t-428 156.5t-160 419.5zM358 1169l127 256h306l127 -256h-213l-70 156l-66 -156h-211zM426 547q0 -160 55.5 -243t155.5 -83t155.5 83t55.5 243q0 161 -55.5 243 t-155.5 82t-155.5 -82t-55.5 -243z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 1273,
    d: "M49 547q0 264 159.5 419.5t428.5 155.5t428.5 -155.5t159.5 -419.5q0 -263 -160 -419.5t-428 -156.5t-428 156.5t-160 419.5zM301 1176q0 142 44.5 208t139.5 66q46 0 80 -7.5t88 -31.5q66 -31 92 -31q17 0 24 15t7 49h197q0 -142 -45 -208.5t-140 -66.5q-46 0 -78.5 7.5 t-88.5 31.5q-76 31 -93 31t-23.5 -14.5t-6.5 -48.5h-197zM426 547q0 -160 55.5 -243t155.5 -83t155.5 83t55.5 243q0 161 -55.5 243t-155.5 82t-155.5 -82t-55.5 -243z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 1273,
    d: "M49 547q0 264 159.5 419.5t428.5 155.5t428.5 -155.5t159.5 -419.5q0 -263 -160 -419.5t-428 -156.5t-428 156.5t-160 419.5zM279 1315q0 69 42 109t111 40q70 0 112 -40.5t42 -108.5q0 -69 -42.5 -109.5t-111.5 -40.5t-111 40.5t-42 109.5zM426 547q0 -160 55.5 -243 t155.5 -83t155.5 83t55.5 243q0 161 -55.5 243t-155.5 82t-155.5 -82t-55.5 -243zM688 1315q0 68 42 108.5t112 40.5q69 0 111 -40t42 -109t-42 -109.5t-111 -40.5t-111.5 40.5t-42.5 109.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    d: "M176 551v197h1004v-197h-1004zM514 264q0 69 47.5 116.5t116.5 47.5t116.5 -47.5t47.5 -116.5t-47.5 -116.5t-116.5 -47.5t-116.5 47.5t-47.5 116.5zM514 1034q0 69 47.5 116.5t116.5 47.5t116.5 -47.5t47.5 -116.5t-47.5 -116.5t-116.5 -47.5t-116.5 47.5t-47.5 116.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 1306,
    d: "M41 80l117 117q-101 144 -101 350q0 264 159.5 419.5t428.5 155.5q203 0 346 -92l129 129l146 -145l-127 -127q94 -139 94 -340q0 -263 -160 -419.5t-428 -156.5q-195 0 -336 86l-123 -123zM434 547q0 -30 4 -70l340 340q-52 55 -133 55q-100 0 -155.5 -82t-55.5 -243z M520 268q50 -47 125 -47q100 0 155.5 83t55.5 243q0 37 -2 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 1310,
    d: "M90 455v639h369v-557q0 -77 8 -150q9 -82 51 -124t127 -42q86 0 136 71.5t50 182.5v619h369v-1094h-369v184l-98 -149q-106 -64 -246 -64q-162 0 -264.5 79t-122.5 198q-10 69 -10 207zM272 1425h328l186 -256h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 1310,
    d: "M90 455v639h369v-557q0 -77 8 -150q9 -82 51 -124t127 -42q86 0 136 71.5t50 182.5v619h369v-1094h-369v184l-98 -149q-106 -64 -246 -64q-162 0 -264.5 79t-122.5 198q-10 69 -10 207zM535 1169l186 256h328l-318 -256h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 1310,
    d: "M90 455v639h369v-557q0 -77 8 -150q9 -82 51 -124t127 -42q86 0 136 71.5t50 182.5v619h369v-1094h-369v184l-98 -149q-106 -64 -246 -64q-162 0 -264.5 79t-122.5 198q-10 69 -10 207zM367 1169l127 256h305l127 -256h-213l-70 156l-65 -156h-211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 1310,
    d: "M90 455v639h369v-557q0 -77 8 -150q9 -82 51 -124t127 -42q86 0 136 71.5t50 182.5v619h369v-1094h-369v184l-98 -149q-106 -64 -246 -64q-162 0 -264.5 79t-122.5 198q-10 69 -10 207zM287 1315q0 69 42 109t111 40q70 0 112 -40.5t42 -108.5q0 -69 -42.5 -109.5 t-111.5 -40.5t-111 40.5t-42 109.5zM696 1315q0 68 42 108.5t112 40.5t112 -40.5t42 -108.5q0 -69 -42.5 -109.5t-111.5 -40.5t-111.5 40.5t-42.5 109.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 1245,
    d: "M0 1094h410l225 -801l223 801h404l-433 -1094q-52 -132 -101.5 -213.5t-111 -131t-132 -67.5t-171.5 -18q-89 0 -155 10v238q31 -4 100 -4q67 0 111 24.5t69 81.5l15 31zM502 1169l186 256h328l-318 -256h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 1370,
    d: "M111 -401v1906h368v-571l82 121q91 67 279 67q220 0 350.5 -152.5t130.5 -398.5q0 -142 -41.5 -257t-112.5 -189.5t-164.5 -114t-199.5 -39.5q-69 0 -140.5 15t-111.5 39l-72 116v-542h-368zM479 514q0 -152 64.5 -222.5t158.5 -70.5q111 0 176.5 85t65.5 247 q0 149 -65.5 234t-165.5 85q-109 0 -171.5 -74t-62.5 -237v-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 1245,
    d: "M0 1094h410l225 -801l223 801h404l-433 -1094q-52 -132 -101.5 -213.5t-111 -131t-132 -67.5t-171.5 -18q-89 0 -155 10v238q31 -4 100 -4q67 0 111 24.5t69 81.5l15 31zM254 1315q0 68 42 108.5t112 40.5q69 0 111 -40t42 -109t-42 -109.5t-111 -40.5t-111.5 40.5 t-42.5 109.5zM664 1315q0 69 42 109t111 40q70 0 112 -40.5t42 -108.5q0 -69 -42.5 -109.5t-111.5 -40.5t-111 40.5t-42 109.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0152",
    horizAdvX: 2324,
    d: "M111 707q0 167 50 306t136.5 232.5t203.5 145t251 51.5q135 0 210.5 -20.5t151.5 -78.5l66 -139v209h1063v-287h-695v-274h654v-287h-654v-278h715v-287h-1083v211l-66 -137q-78 -61 -151.5 -82t-210.5 -21q-134 0 -251 52t-203.5 145.5t-136.5 233t-50 305.5zM487 707 q0 -222 92.5 -343.5t254.5 -121.5q161 0 253.5 121.5t92.5 343.5q0 223 -92 343.5t-254 120.5t-254.5 -120.5t-92.5 -343.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0153",
    horizAdvX: 2029,
    d: "M49 547q0 264 159.5 419.5t428.5 155.5q125 0 229 -51t174 -156q136 207 410 207q101 0 187.5 -31t148.5 -85t106.5 -125.5t66 -152.5t21.5 -167q0 -51 -6 -106h-762q13 -128 65.5 -181t137.5 -53q77 0 124 36.5t58 100.5h363q-47 -184 -190.5 -285.5t-348.5 -101.5 q-259 0 -391 191q-133 -191 -393 -191q-268 0 -428 156.5t-160 419.5zM426 547q0 -160 55.5 -243t155.5 -83t155.5 83t55.5 243q0 161 -55.5 243t-155.5 82t-155.5 -82t-55.5 -243zM1225 680h370q-13 95 -60 143.5t-122 48.5q-149 0 -188 -192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0178",
    horizAdvX: 1357,
    d: "M29 1413h413l279 -559l268 559h404l-498 -872v-541h-369v541zM352 1628q0 69 42.5 109.5t111.5 40.5t111 -40.5t42 -109.5t-42 -109t-111 -40q-70 0 -112 40.5t-42 108.5zM762 1628q0 69 42 109.5t111 40.5t111.5 -40.5t42.5 -109.5q0 -68 -42 -108.5t-112 -40.5 q-69 0 -111 40t-42 109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C6",
    horizAdvX: 614,
    d: "M29 1169l127 256h305l127 -256h-213l-70 156l-65 -156h-211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DC",
    horizAdvX: 614,
    d: "M-29 1176q0 142 45 208t140 66q46 0 80 -7.5t88 -31.5q66 -31 92 -31q17 0 23.5 14.5t6.5 49.5h197q0 -142 -44.5 -208.5t-139.5 -66.5q-46 0 -79.5 7.5t-88.5 31.5q-76 31 -92 31q-17 0 -24 -14.5t-7 -48.5h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2000",
    horizAdvX: 954
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2001",
    horizAdvX: 1909
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2002",
    horizAdvX: 954
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2003",
    horizAdvX: 1909
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2004",
    horizAdvX: 636
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2005",
    horizAdvX: 477
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2006",
    horizAdvX: 318
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2007",
    horizAdvX: 318
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2008",
    horizAdvX: 238
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2009",
    horizAdvX: 381
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u200A",
    horizAdvX: 106
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2010",
    horizAdvX: 643,
    d: "M66 481v197h512v-197h-512z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2011",
    horizAdvX: 643,
    d: "M66 481v197h512v-197h-512z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2012",
    horizAdvX: 643,
    d: "M66 481v197h512v-197h-512z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 1024,
    d: "M184 496v196h656v-196h-656z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 2048,
    d: "M184 496v196h1680v-196h-1680z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 659,
    d: "M119 899v21l223 585h283l-164 -606h-342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 659,
    d: "M35 899l164 606h342v-20l-224 -586h-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 544,
    d: "M-53 -254l164 606h342v-20l-224 -586h-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 1150,
    d: "M119 899v21l223 585h283l-164 -606h-342zM610 899v21l224 585h282l-164 -606h-342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 1150,
    d: "M35 899l164 606h342v-20l-224 -586h-282zM526 899l164 606h342v-20l-223 -586h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 1036,
    d: "M-53 -254l164 606h342v-20l-224 -586h-282zM438 -254l164 606h342v-20l-223 -586h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 802,
    d: "M135 625q0 120 73 193t193 73t193.5 -73t73.5 -193t-73.5 -193.5t-193.5 -73.5t-193 73.5t-73 193.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2026",
    horizAdvX: 1691,
    d: "M82 176q0 91 57 148t148 57t148 -57t57 -148t-57 -148t-148 -57t-148 57t-57 148zM655 176q0 91 57 148t148 57t148 -57t57 -148t-57 -148t-148 -57t-148 57t-57 148zM1229 176q0 91 57 148t148 57t147.5 -57t56.5 -148t-56.5 -148t-147.5 -57t-148 57t-57 148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u202F",
    horizAdvX: 381
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 935,
    d: "M301 508l281 340h264l-281 -340l281 -340h-264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 868,
    d: "M90 168l281 340l-281 340h264l281 -340l-281 -340h-264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u205F",
    horizAdvX: 477
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u20AC",
    d: "M76 459l41 196h114v45q0 40 2 58h-94l41 196h80q58 242 223.5 365t395.5 123q285 0 415 -127l-127 -228q-66 46 -126.5 65t-143.5 19q-190 0 -252 -217h467l-43 -196h-453v-49v-54h431l-39 -196h-367q31 -121 98 -169t174 -48q165 0 301 80v-265q-80 -46 -165 -66 t-230 -20q-479 0 -567 488h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2122",
    horizAdvX: 1099,
    d: "M45 1260v92h418v-92h-148v-326h-122v326h-148zM512 934v416h186l68 -291l68 291h178v-416h-123l4 291l-66 -283h-127l-67 281l2 -289h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u25FC",
    horizAdvX: 1095,
    d: "M0 0v1096h1096v-1096h-1096z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "U",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "U",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "U",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "U",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "U",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "U",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "U",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 201
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "z",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "period,ellipsis",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,uniFB02",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,uniFB02",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "T",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Y,Yacute,Ydieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,oe",
    g2: "x",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,oe",
    g2: "y,yacute,ydieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "T",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Y,Yacute,Ydieresis",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "W",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Z",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "period,ellipsis",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 274
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y,Yacute,Ydieresis",
    k: 260
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 209
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 168
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "T",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "v",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "Y,Yacute,Ydieresis",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "y,yacute,ydieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "V",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "W",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "t",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "quoteright,quotedblright",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "S",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "w",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "m,n,p,r,ntilde",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "i,igrave,iacute,icircumflex,idieresis",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "x",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "y,yacute,ydieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAileronBlackWebfont);
export default __webpack_public_path__ + "static/media/aileron-black-webfont.e650d4c84536f9308d147fb3675a96c2.svg";
export { ForwardRef as ReactComponent };